import { ReferentialKey } from "api/referential";
import { ReferentialAction } from "./actions/types";
import { ReferentialState } from "./types";

export const initialState: ReferentialState = {
  dropdownItems: {
    [ReferentialKey.Civility]: [],
    [ReferentialKey.LegalForm]: [],
    [ReferentialKey.Nationality]: [],
    [ReferentialKey.Country]: [],
    [ReferentialKey.CompanyRole]: [],
    [ReferentialKey.MandateFrequency]: [],
    [ReferentialKey.QuestionsContexts]: [],
    [ReferentialKey.ProjectType]: [],
    [ReferentialKey.InsuranceProject]: [],
    [ReferentialKey.LoanType]: [],
    [ReferentialKey.DefermentType]: [],
    [ReferentialKey.InterestRateType]: [],
    [ReferentialKey.ProspectType]: [],
  },
  referentials: {
    [ReferentialKey.Civility]: [],
    [ReferentialKey.LegalForm]: [],
    [ReferentialKey.Nationality]: [],
    [ReferentialKey.Country]: [],
    [ReferentialKey.CompanyRole]: [],
    [ReferentialKey.MandateFrequency]: [],
    [ReferentialKey.QuestionsContexts]: [],
    [ReferentialKey.ProjectType]: [],
    [ReferentialKey.InsuranceProject]: [],
    [ReferentialKey.LoanType]: [],
    [ReferentialKey.DefermentType]: [],
    [ReferentialKey.InterestRateType]: [],
    [ReferentialKey.ProspectType]: [],
  },
  isLoading: false,
  error: null
}

export const referentialReducer = (
  state: ReferentialState,
  action: ReferentialAction): ReferentialState => {
  switch (action.type) {
    case 'SET_SINGLE_ITEM':
      return {
        ...state,
        dropdownItems: {
          ...state.dropdownItems,
          [action.payload.referentialKey]: action.payload.dropdownItem
        },
        referentials: {
          ...state.referentials,
          [action.payload.referentialKey]: action.payload.referential
        }
      }
    case 'SET_DROPDOWN_ITEMS':
      return {
        ...state,
        dropdownItems: {
          ...state.dropdownItems,
          ...action.payload
        }
      }
    case 'SET_REFERENTIALS':
      return {
        ...state,
        referentials: {
          ...state.referentials,
          ...action.payload
        }
      }
    case 'SET_LOADING':
      return { ...state, isLoading: action.payload }
    case 'SET_ERROR':
      return { ...state, error: action.payload, isLoading: false }
    case 'RESET':
      return initialState
    default:
      return state
  }
}
